import { initializeApp } from "firebase/app";
import { getFirestore, doc, setDoc, serverTimestamp } from "firebase/firestore";
import {
  getAuth,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBynx46t8l1qKBPhx9x29fr-LXkx1mRYVU",
  authDomain: "life-command-center-ad7eb.firebaseapp.com",
  projectId: "life-command-center-ad7eb",
  storageBucket: "life-command-center-ad7eb.firebasestorage.app",
  messagingSenderId: "448309853656",
  appId: "1:448309853656:web:50c88a1e01b1f6b1cb86ad"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Thin wrappers, same directness as App.js's handleLogin (one line, straight SDK call) —
// deliberately NOT wrapped in a swallowing try/catch, unlike handleLogin, so Prompt 2's
// signup/login form can surface real error messages (wrong password, email in use, etc.).
export const signUpWithEmail = (email, password) => createUserWithEmailAndPassword(auth, email, password);
export const signInWithEmail = (email, password) => signInWithEmailAndPassword(auth, email, password);

// Not wired to any UI yet — Prompt 2 calls this after signup. setDoc with merge:true so a
// re-login (Google or password) never clobbers an existing profile.
export async function createUserProfile(uid, email, accountType, authProvider) {
  await setDoc(
    doc(db, "users", uid),
    { email, accountType, authProvider, createdAt: serverTimestamp() },
    { merge: true }
  );
}

export default app;